import { useApi } from '@/api';
import type { GetRevenueDynamicsResponse } from '@/api/handlers/resources/sales/responses/GetRevenueDynamicsResponse';
import type { ApiResponse } from '@/api/handlers/responses/ApiResponse';
import { useQuery } from '@tanstack/react-query';
import { SalesQueryKeys } from './salesQueryKeys';

export type UseRevenueDynamicsQueryParams = {
    from: string;
    to: string;
    productId?: string | null;
};

/**
 * Revenue-dynamics query. The `queryKey` carries `from` / `to` /
 * `productId` so changing the page-level period filter or the
 * widget's product picker triggers a refetch automatically.
 */
export const useRevenueDynamicsQuery = (
    params: UseRevenueDynamicsQueryParams,
    enabled = true,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetRevenueDynamicsResponse>>({
        queryKey: SalesQueryKeys.revenueDynamics(
            params.from,
            params.to,
            params.productId ?? null,
        ),
        queryFn: () =>
            apiClient.sales.getRevenueDynamics({
                from: params.from,
                to: params.to,
                productId: params.productId ?? null,
            }),
        enabled,
        staleTime: 60_000,
    });
};
